// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamFollowAddBody = {
  teamId: string;
};

export type typeTeamFollowAddOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { favoriteTeamIds: string[] };
};

export type typeTeamFollowAddOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamFollowAddOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamFollowAddOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamFollowAddBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamFollowAdd(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamFollowAddBody);
  }

  return async function postTeamFollowAdd(
    payload: typeTeamFollowAddBody,
  ): Promise<typeTeamFollowAddOutput200 | typeTeamFollowAddOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamFollowAdd" failed before calling the network. #9b8ea2824583`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#9b8ea2824583" },
        },
        data: null,
      } as typeTeamFollowAddOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team-follow/add`,
      httpMethod: "POST",
      options,
    })) as typeTeamFollowAddOutput200 | typeTeamFollowAddOutput400;
  };
}
